import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Redirect, useLocation } from 'react-router-dom';
import qs from 'qs';
/**
 * StoreToken
 * simple path-parsing component to extract `token` from queryParams if it exists, store it as the auth
 * token and redirect to a path without the token.
 */
export function StoreToken({ children, setToken }) {
    const location = useLocation();
    const params = qs.parse(location.search, { ignoreQueryPrefix: true, strictNullHandling: true });
    if (typeof (params === null || params === void 0 ? void 0 : params.token) === 'string') {
        setToken(params.token);
        delete params.token;
        const searchSansToken = qs.stringify(params, { strictNullHandling: true });
        return _jsx(Redirect, { to: { pathname: location.pathname, search: searchSansToken } }, void 0);
    }
    /**
     * Typescript is making me wrap this in a fragment - it doesn't like directly returning
     * children (even though that's a valid pattern)
     */
    return _jsx(_Fragment, { children: children }, void 0);
}
//# sourceMappingURL=StoreToken.js.map